<template>
  <b-container fluid class="py-3">
    <b-row>
      <b-col>
        <SkeletonTableLoader :columns="headers" :loading="loading" />
        <div v-if="!loading">
          <Tableview :value="items" :paginator="true" class="p-datatable-gridlines" :rows="10" :rowHover="true"
            filterDisplay="menu" :loading="loading" responsiveLayout="scroll" :columns="headers"
            :globalFilterFields="globalFilterFields" :filters="filters" selectionMode="single" dataKey="RowNumber"
            @row-click="RowClick">
            <template v-slot:IsAdmittedStatus="{ data }">
              <!-- <Badge v-if="data.IsAdmitted == '0'" severity="warning">{{
                                "-"
                                }}</Badge> -->
              <span v-if="data.IsAdmitted == '0'">-</span>
              <Badge v-if="data.IsAdmitted == '1'" severity="success">{{
                "Admitted"
              }}</Badge>
            </template>
          </Tableview>
        </div>
      </b-col>
    </b-row>
  </b-container>
  <ItemAllocatioNPopup v-model:showIOLDialog="showIOLDialog" showitems="pending" v-if="showIOLDialog"
    @closepopup="isClear" :PatientDetails="PatientDetails" />
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted, watch } from "vue";
import moment from "moment";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";

import Tableview from "../../../../../components/FormComponents/Table.vue";
import SkeletonTableLoader from "../../../../../components/FormComponents/SkeletonTableLoader.vue";

import { FilterMatchMode, FilterOperator } from "primevue/api";
import ItemAllocatioNPopup from "../../../../../modules/Inventory/pages/Transaction/PatientIssue/ItemAllocationPopup.vue";
import PatientIssueService from "../../../../../modules/Inventory/Service/PatientIssueService";

export default defineComponent({
  components: {
    Tableview,
    ItemAllocatioNPopup,
    SkeletonTableLoader,
  },
  props: {
    FilterObj: {
      type: Object,
      default: {},
    },
  },

  setup(props, { emit }) {
    const router = useRoute();
    const loading = ref(false);
    const showIOLDialog = ref(false);
    const items = ref([]);
    let PatientDetails = ref({});

    const headers = [
      {
        header: "#",
        field: "RowNumber",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: "Admitted Status",
        field: "",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        slot: "IsAdmittedStatus",
        fieldDisplay: "false",
      },
      {
        header: "UIN",
        field: "uin",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: "MRN No",
        field: "mrno",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: "Patient Name",
        field: "patientName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Patient Type",
        field: "patientType",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Surgery Name",
        field: "surgery",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "width150",
      },
      {
        header: "Lens Diaptor",
        field: "iolPower",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
    ];

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Code: { value: null, matchMode: FilterMatchMode.IN, options: items },
      TemplateInfo: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
    };

    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });

    const globalFilterFields = ref(headers.map((col) => col.field));

    onMounted(() => {
      ReadyFunction();
    });

    const ReadyFunction = () => {
      debugger;
      LoadPendingTable();
    };

    interface obj {
      Date: string;
      SiteId: number | 0;
    }

    const Obj = ref<obj>({
      // Date: "2024-01-11",
      Date: moment().format("YYYY-MM-DD"),
      SiteId: Number(router.query.SiteId) || 0,
    });

    const LoadPendingTable = async (): Promise<void> => {
      debugger;
      try {
        loading.value = true;
        const response =
          await PatientIssueService.GetExpectedPatientSurgeryList(Obj.value);

        let RowNumber = 0;
        items.value = response["result"].map((item) => {
          RowNumber = RowNumber + 1;
          item.RowNumber = RowNumber;
          return item;
        });

        loading.value = false;
      } catch (error) {
        console.error("Error loading pending table:", error);
        loading.value = false;
      }
    };

    watch(
      () => [props.FilterObj.Date],
      ([newFilterObj]) => {
        debugger;
        if (newFilterObj) {
          Obj.value.Date = newFilterObj;
          LoadPendingTable();
        }
      },
      { immediate: true }
    );

    function RowClick(Obj) {
      debugger;
      // if (Obj.data.IsAdmitted == 1) {

      PatientDetails.value = Obj.data;
      showIOLDialog.value = true;
      // }
    }

    function isClear() {
      showIOLDialog.value = false;
    }

    return {
      items,
      loading,
      filteredColumns,
      globalFilterFields,
      headers,
      filters,
      RowClick,
      showIOLDialog,
      isClear,
      PatientDetails,
    };
  },
});
</script>

<style lang="scss" scoped></style>
